import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { FooterReport, Gap, Line } from "../../../../components/Global";

const LoadingPage = () => {
    require("../Pemetaan.css");
    return (
        <div className="report-page">
            <div className="header-first-page">
                <div className="text-header">
                    <div className="title-header">SCHOOL ASSESSEMENT REPORT</div>
                    <div className="sub-title-header">Pemetaan Kurikulum Merdeka Belajar</div>
                </div>
                <div className="img-header">
                    <img src="/assets/image/pemetaan.png" width={"20%"} />
                </div>
            </div>
            <Gap height={20} />
            <div style={{ width: "95%", paddingLeft: "5%" }}>
                <Line color={"#1D3557"} />
            </div>
            <Gap height={20} />
            <div className="section-one">
                <SkeletonTheme baseColor="#d4d2d2" highlightColor="#a6a6a6">
                    <Skeleton count={20} height={30} />
                </SkeletonTheme>
            </div>
            {/* <Gap height={40} />
            <div className="reportFooter">
                <FooterReport color={"#1D3557"} date={"20/02/2022"} />
            </div> */}
        </div>
    );
};

export default LoadingPage;
